import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=73b2d200&"
var script = {}
import style0 from "./MenuButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports